import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonIcon,
  CheckItem,
  FormHeader,
  InputBox,
} from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import {
  closeSelectTagsModal,
  setSelectedTags,
  setTagsList,
} from "../../Tags/redux/actions";
import { getAllTags } from "../../Tags/service/tags.service";

const Index = (props) => {
  const [formData, setFormData] = useState({
    tagName: {
      key: "tagName",
      label: "Tag Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [filteredTags, setFilteredTags] = useState([]);
  const [selectedTags, setSelectTags] = useState([]);

  const { isOpenSelectTagsModal, tagsList } = useSelector(
    ({ tagsReducer }) => tagsReducer
  );

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };

  const fetchTags = async () => {
    const updateForm = { ...formData };
    updateForm.tagName.loading = true;
    updateForm["tagName"].elementConfig.options = [];
    const response = await getAllTags();
    if (response?.data) {
      let tagNameList = await syncTagName(response.data);
      updateForm["tagName"].elementConfig.options = tagNameList;
      updateForm.tagName.loading = false;
      dispatch(setTagsList(response.data));

      setFormData(updateForm);
    }
  };

  const syncTagName = async (res) => {
    let tagList = [];
    for (let tag of res) {
      const articleCount = tag.article_ids?.length || 0;
      tagList.push({
        id: tag.tag_id,
        key: `${tag.tag_name} (${articleCount})`,
        value: tag.tag_id,
        displayValue: `${tag.tag_name} (${articleCount})`,
      });
    }
    return tagList;
  };

  useEffect(() => {
    if (tagsList?.length === 0) {
      fetchTags();
    }
  }, []);

  const updateForm = { ...formData };

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenSelectTagsModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container w-400 center_me d-flex flex-column  animate__animated  ${
          isOpenSelectTagsModal ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        <div className="common-modal-close">
          <ButtonIcon
            data={{ iconName: "cross", size: "sm" }}
            onClick={() => dispatch(closeSelectTagsModal())}
          />
        </div>
        <div className="hne-create-tag-wrapper">
          <FormHeader
            data={{
              formHeader: "Select Tags",
              size: "md-md",
            }}
          />
          <div className="hne-tag-header-wrapper">
            <InputBox
              data={updateForm.tagName}
              onChange={async (e) => {
                const inputValue = e.target.value;
                await handleChange(inputValue, updateForm.tagName.key);

                const filtered = tagsList?.filter((item) =>
                  item?.tag_name
                    ?.toLowerCase()
                    .includes(inputValue.toLowerCase())
                );

                setFilteredTags(
                  filtered?.length > 0 && inputValue !== "" ? filtered : []
                );
              }}
            />

            <div
              className="d-flex flex-row flex-wrap mt-2"
              style={{ gap: "8px" }}
            >
              {Array.isArray(filteredTags) && filteredTags.length > 0 ? (
                filteredTags.map((item) => {
                  const isActive = selectedTags?.includes(item?.tag_id); // Make this synchronous

                  return (
                    <div className="d-flex" key={item.id}>
                      <CheckItem
                        data={{
                          checkName: item?.tag_name,
                          isActive,
                          type: "border p-1",
                        }}
                        onClick={() => {
                          if (!selectedTags.includes(item?.tag_id)) {
                            setSelectTags([...selectedTags, item?.tag_id]);
                          } else {
                            setSelectTags(
                              selectedTags.filter((tag) => tag !== item?.tag_id)
                            );
                          }
                        }}
                      />
                    </div>
                  );
                })
              ) : (
                <div className="error-message">No Tags Found</div>
              )}
            </div>
          </div>

          <Button
            data={{
              btnName: "DONE",
              buttonType:
                updateForm.tagName.value === ""
                  ? "primary disabled"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disable: updateForm.tagName.value === "" ? true : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              dispatch(setSelectedTags(selectedTags));
              dispatch(closeSelectTagsModal());
            }}
          />
        </div>
      </div>
    </>
  );
};
export default Index;
